/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { InitiateRequestBuilderRequestsMetadata, type InitiateRequestBuilder } from './initiate/index.js';
// @ts-ignore
import { type WithAudioInputItemRequestBuilder, WithAudioInputItemRequestBuilderNavigationMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /files/{file-id}/revisions/{revisionId}/edit/audio/uploads
 */
export interface UploadsRequestBuilder extends BaseRequestBuilder<UploadsRequestBuilder> {
    /**
     * The initiate property
     */
    get initiate(): InitiateRequestBuilder;
    /**
     * Gets an item from the ApiSdk.files.item.revisions.item.edit.audio.uploads.item collection
     * @param audioInputId Unique identifier of the item
     * @returns {WithAudioInputItemRequestBuilder}
     */
     byAudioInputId(audioInputId: Guid) : WithAudioInputItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const UploadsRequestBuilderUriTemplate = "{+baseurl}/files/{file%2Did}/revisions/{revisionId}/edit/audio/uploads";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const UploadsRequestBuilderNavigationMetadata: Record<Exclude<keyof UploadsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byAudioInputId: {
        navigationMetadata: WithAudioInputItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["audioInputId"],
    },
    initiate: {
        requestsMetadata: InitiateRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
